import managers from '../api/managers'
import gql from 'graphql-tag';
import { apolloClient } from '@/apollo';

export default {
  state: {
    affiliateManagers: [],
    affiliatesByManager: [],
    accountManagers: [],
    umbrellaUsers: [],
    filters: [],
    signupLink: '',
  },
  namespaced: true,
  mutations: {
    async saveAffiliateManagers(state, affiliateManagers) {
      state.affiliateManagers = affiliateManagers
    },
    async saveAffiliatesByManager(state, affiliatesByManager) {
      state.affiliatesByManager = affiliatesByManager
    },
    async saveAccountManagers(state, accountManagers) {
      state.accountManagers = accountManagers
    },
    async saveSignupLink(state, signupLink) {
      state.signupLink = signupLink
    },
    async saveUmbrellaUsersUsers(state, data) {
        state.umbrellaUsers = data
    },
    async createOrUpdateAccountManager(state, newData) {
        const currentDate = new Date();
        newData.dateUpdated = currentDate.toISOString().slice(0, 19).replace('T', ' ');

        if (newData.isSwitchStatus){
            state.accountManagers.data = state.accountManagers.data.map(item => item.id === newData.id ? newData : item);
        } else {
            if (newData.isEdit){
                state.accountManagers.data = state.accountManagers.data.map(item => item.id === newData.id ? newData : item);
            } else {
                newData.dateAdded = currentDate.toISOString().slice(0, 19).replace('T', ' ');
                state.accountManagers.count = state.accountManagers.count || 1;
                state.accountManagers.data.unshift(newData)
            }
        }
    },
    async getAccountManagerFilterData(state, data) {
        state.filters = data.filters
    },
    async deleteManager(state, id) {
        state.accountManagers.data = state.accountManagers.data.filter(item => item.id !== id);
    }
  },
  actions: {
    async saveAffiliateManagers({dispatch, commit}, data) {
        try {
            commit('saveAffiliateManagers', await managers.getAffiliateManagers(data))
        } catch (err) {
            dispatch('alert/ALERT_ERROR', err.message, {root: true});
        }
    },

    async saveAffiliatesByManager({dispatch, commit}, managerId) {
      try {
        commit('saveAffiliatesByManager', await managers.getAffiliateByManager(managerId))
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveAccountManagers({dispatch, commit}, data) {
      const pagination = {
          limit: data.limit,
          page: data.page
      }
      const sorting = {
          orderBy: data.orderBy,
          orderDirectionAsc: data.orderDirectionAsc
      }
      const filters = data.filters
      const isShowInactive = data.isShowInactive
      try {
          const resp = await managers.getAccountManager(pagination, sorting, filters, isShowInactive)
          commit('saveAccountManagers', resp);
      } catch (err) {
          dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveUmbrellaUsers({dispatch, commit}, data) {
      try {
          commit('saveUmbrellaUsersUsers', await managers.getUmbrellaUsers(data))
      } catch (err) {
          dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async createOrUpdateAccountManagerStore({dispatch, commit}, data) {
        try {
            const resp = await managers.createOrUpdateAccountManager(data)
            if (resp.id){
                dispatch('alert/ALERT_SUCCESS', 'Account Manager has been successfully created/updated ',  {root: true});
                data.id = resp.id;
                commit('createOrUpdateAccountManager', data)
            } else {
                dispatch('alert/ALERT_ERROR', 'Account Manager has not been created/updated ',  {root: true});
            }
        } catch (e) {
            dispatch('alert/ALERT_ERROR', 'Account Manager has not been created/updated ',  {root: true});
        }
    },
    async getSignupLink({dispatch, commit}, data) {
      commit('saveSignupLink', await managers.getSignupLink(data))
    },
     async getAccountManagerFilterDataStore({dispatch, commit}, data) {
        try {
            const resp = await managers.getAccountManagerFilterData(data)
            commit('getAccountManagerFilterData',resp);
            return resp;
        } catch (e) {
            console.error('getAccountManagerFilterDataStore Error:',e)
        }
     },
    async deleteManagerStore({commit, dispatch}, id) {
      try {
          const resp = await managers.deleteManager(id)
          if (!resp) {
              commit('deleteManager',id);
              dispatch('alert/ALERT_SUCCESS', 'Account Manager has been successfully deleted ',  {root: true});
              return true
          } else {
              dispatch('alert/ALERT_ERROR', 'Unable to delete. Account Manager privileges required ',  {root: true});

              return false
          }
      } catch (e) {
          console.error('deleteManagerStore Error:',e)
          dispatch('alert/ALERT_ERROR', 'Unable to delete. Account Manager privileges required',  {root: true});
          return false;
      }
    },
    async generateAgentToken({commit, dispatch}, data) {
      try {
          const mutationQuery = gql`
              mutation GenerateAgentToken($agentName: String!, $userEmail: String!) {
                generateAgentToken(agent_name: $agentName, user_email: $userEmail)
              }
          `;
          const { agentName, userEmail } = data

          const response = await apolloClient.mutate({
              mutation: mutationQuery,
              variables: { agentName, userEmail },
          });

          return response.data.generateAgentToken;
      } catch (error) {
          console.error('Error generating agent token:', error);
          throw new Error(error.message);
      }
    }
  },
  getters: {
      affiliateManagers: state => state.affiliateManagers,
      affiliatesByManager: state => state.affiliatesByManager,
      signupLink: state => state.signupLink,
      getAccountManagers: state => state.accountManagers,
      getUmbrellaUsers: state => state.umbrellaUsers,
      filters: state => state.filters,
  },

}
